import {lazy} from "react";
const RichTextEditor = lazy(() => import("./widgets/Editor/RichTextEditor"));

const exports = {
    widgets: {
        Editor: RichTextEditor,
    }
}
export default exports;